import APIService from '../../services/APIService';

const FORGOT_PASSWORD_QUERY = `query ($username: String!, $resetPasswordPath: String!) {
    forgotPassword(username: $username, resetPasswordPath: $resetPasswordPath) {
        status
        message
    }
}`;

const sendForgotPasswordEmail = async (username) => {
    const payload = {
        query: FORGOT_PASSWORD_QUERY,
        variables: {
            username: username.trim(),
            resetPasswordPath: `${document.location.origin}/Login/ResetPassword`
        }
    };

    // document.cookie = 'env=R2NET-51874; domain=.r2net.com; path=/; Secure; SameSite=None';

    const data = await APIService.post('https://passport-api.services.r2net.com/auth', payload, undefined, { 'app-id': 'dmarket' });
    return data;
};

export default sendForgotPasswordEmail;
